module.exports = __webpack_public_path__ + "static/media/ns.991a5664.png";